// Photography data configuration
// Base URL for Cloudflare R2 storage
const R2_BASE_URL = "https://pub-0ff494654bf448eab2bc7515c93a5350.r2.dev";

// Photography collection data
export const photographyData = [

  {
    id: "photo-003",
    filename: "ED54BFC2-DE90-403E-8C50-698027D31714-4722-000000E50C9CF2F0.JPG", 
    title: "Mexico City, Mexico",
    description: "Found a talented street artist painting for $3 each. Had to get 10+ for my friends",
    // category: "architecture",
    // tags: ["architecture", "modern", "design"],
    // date: "2024"
  },
  {
    id: "photo-004",
    filename: "R0021839.JPG",
    title: "Xiangtan, China",
    description: "Made with love - clay gift from my friend",
    // category: "nature",
    // tags: ["landscape", "nature", "peaceful"],
    // date: "2024"
  },
  {
    id: "photo-005",
    filename: "R0022631.jpg",
    title: "Shanghai, China",
    description: "A glimpse on the way home",
    // category: "nature",
    // tags: ["golden hour", "lighting", "magic"],
    // date: "2024"
  },
  {
    id: "photo-006",
    filename: "R0022854.JPG",
    title: "Xiangtan, China",
    description: "Racing home for my childhood friend's wedding",
    // category: "travel",
    // tags: ["travel", "memory", "adventure"],
    // date: "2024"
  },
  // {
  //   id: "photo-007",
  //   filename: "R0022862.JPG",
  //   title: "Street Photography",
  //   description: "Life happening in the streets",
  //   category: "street",
  //   tags: ["street", "life", "spontaneous"],
  //   date: "2024"
  // },
  {
    id: "photo-008",
    filename: "R0023090.JPG",
    title: "Datong, China",
    description: "Buddha across the millennia",
    // category: "nature",
    // tags: ["nature", "details", "close-up"],
    // date: "2024"
  },
  {
    id: "photo-009",
    filename: "R0023713.JPG",
    title: "Whitefish, MT, USA",
    description: "Experiencing American rail travel for the first time - aboard the Empire(Seattle -> St.Paul)",
    // category: "nature",
    // tags: ["evening", "light", "beautiful"],
    // date: "2024"
  },
  // {
  //   id: "photo-010",
  //   filename: "R0023725.JPG",
  //   title: "City Sunset",
  //   description: "When the city meets the sunset",
  //   category: "urban",
  //   tags: ["city", "sunset", "urban landscape"],
  //   date: "2024"
  // },
  {
    id: "photo-011",
    filename: "R0024019.JPG",
    title: "Minneapolis, MN, USA",
    description: "Back to Minneapolis again, to see old friends",
  },
  {
    id: "photo-012",
    filename: "R0024537.JPG",
    title: "Monterey, CA, USA",
    description: "Discovering California, one road at a time",
  },
  {
    id: "photo-013",
    filename: "R0024574.JPG",
    title: "Cambria, CA, USA",
    description: "Strong ocean breeze, but so warm",
  },
  // {
  //   id: "photo-014",
  //   filename: "R0024578.JPG",
  //   title: "Final Shot",
  //   description: "The perfect ending to a photography session",
  // }
    {
    id: "photo-001",
    filename: "4EFEB87F-EE67-4A91-BA62-13CCBB673383-56284-00000D13963A9169.JPG",
    title: "Gangneung, South Korea",
    description: "Graduation traval with high school friend in summer",
    // category: "street",
    // tags: ["urban", "candid", "street photography"],
    // date: "2024"
  },
  {
    id: "photo-002", 
    filename: "94254AF3-61D6-40AB-88C7-564350EB5EE2-56284-00000D121D6DC4AE.JPG",
    title: "Busan, South Korea",
    description: "An isnland in sea",
    // category: "urban",
    // tags: ["city", "energy", "urban life"],
    // date: "2024"
  },
];

// Helper functions for photo management
export const photoUtils = {
  // Generate full URL for a photo
  getPhotoUrl: (filename) => `${R2_BASE_URL}/${filename}`,
  
  // Get photo by ID
  getPhotoById: (id) => photographyData.find(photo => photo.id === id),
  
  // Get photos by category
  getPhotosByCategory: (category) => photographyData.filter(photo => photo.category === category),
  
  // Get photos by tag
  getPhotosByTag: (tag) => photographyData.filter(photo => photo.tags.includes(tag)),
  
  // Get all categories
  getAllCategories: () => [...new Set(photographyData.map(photo => photo.category))],
  
  // Get all tags
  getAllTags: () => [...new Set(photographyData.flatMap(photo => photo.tags))],
  
  // Transform data for gallery component
  transformForGallery: () => photographyData.map(photo => ({
    id: photo.id,
    src: photoUtils.getPhotoUrl(photo.filename),
    alt: photo.title,
    description: photo.description,
    // category: photo.category,
    // tags: photo.tags,
    // date: photo.date
  }))
};

// Export processed data for easy use
export const galleryPhotos = photoUtils.transformForGallery();